import fp from 'lodash/fp';
import { configurations } from './configurations';
import { apiAction as getBusinessReport } from './configurations/getBusinessReport';
import { apiAction as getReport } from './configurations/getReport';
import { apiAction as getUsers } from './configurations/getUsers';

export const apiActions = {
  admin: {
    getUsers,
    getReport,
    getBusinessReport
  }
}

const actions = {
  admin: {
    api: {
      ...fp.reduce(
        (prev, { name, action: { admin: { api } } }) => ({
          ...prev,
          [name]: api[name]
        }),
        {}
      )(configurations)
    },
    ...fp.reduce(
      (prev, { name, action: { admin } }) => ({
        ...prev,
        [name]: admin[name]
      }),
      {}
    )(configurations)
  }
};

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/admin/actions.js